<template>
  <div>
    <div
        v-if="showSelf"
        class="page-wrap">
      <my-header
          :current-title="['发票业务', '发票额度调整申请']"
          main-title="发票额度调整申请"
          @back="emit('go-invoice')"
      />

      <div class="content-box">
        <div class="main-box">
          <el-form :model="queryParams"
                   class="query-form"
                   ref="formRef" :rules="rules" :inline="true" label-width="100px">
            <el-form-item

                label="申请日期(起)" prop="reqStart">
              <el-date-picker
                  type="date"
                  v-model="queryParams.reqStart"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disableReqStart"
                  clearable
                  style="width: 181px"
              />
            </el-form-item>

            <el-form-item label="申请日期(止)" prop="reqEnd">
              <el-date-picker
                  type="date"
                  v-model="queryParams.reqEnd"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disableReqEnd"
                  clearable
                  style="width: 181px"
              />
            </el-form-item>

            <el-form-item label="申请调整额度类型"
                          label-width="130px"
                          prop="adjustType">
              <el-select
                  v-model="queryParams.adjustType"
                  style="width: 201px"
                  placeholder="请选择">
                <el-option label="全部" value="全部"/>
                <el-option label="短期" value="短期"/>
                <el-option label="长期" value="长期"/>
              </el-select>
            </el-form-item>

            <el-form-item label="审核状态"
                          prop="checkStatus">
              <el-select
                  multiple
                  collapse-tags
                  clearable
                  v-model="queryParams.checkStatus"
                  style="width: 201px;"
                  placeholder="请选择">
                <el-option label="已提交" value="已提交"/>
                <el-option label="已撤销" value="已撤销"/>
                <el-option label="受理中" value="受理中"/>
                <el-option label="不予受理" value="不予受理"/>
                <el-option label="待补正" value="待补正"/>
                <el-option label="审核中" value="审核中"/>
                <el-option label="审核通过" value="审核通过"/>
                <el-option label="审核不通过" value="审核不通过"/>
              </el-select>
            </el-form-item>
          </el-form>

          <div style="display: flex;flex-direction: row-reverse;">
            <el-button icon="ArrowUp">收起</el-button>
            <el-button type="primary" @click="queryData()" style="margin-right: 12px;">查询</el-button>
            <el-button type="info">重置</el-button>
          </div>

          <div style="display: flex;align-items: center;margin-top: 20px;">
            <el-button
                type="primary"
                @click="addReq"
            >新增申请
            </el-button>

            <div style="flex-grow: 1;"></div>

            <el-button
            >自定义列
            </el-button>
          </div>

          <el-table
              ref="tableRef"
              :data="showTableList"
              class="adjust-tax-table"
              style="margin-top: 10px;"
              border
          >
            <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

            <el-table-column label="申请日期" align="center" prop="reqDate" min-width="120"/>

            <el-table-column label="申请调整额度类型" align="center" prop="adjustType" width="150"/>

            <el-table-column label="生效日期" align="center" prop="validateStart" min-width="120"/>

            <el-table-column label="失效日期" align="center" prop="validateEnd" min-width="120"/>

            <el-table-column label="有效状态" align="center" prop="validDate" width="150"/>

            <el-table-column label="审核状态" align="center" prop="checkStatus" width="150"/>

            <el-table-column label="发票额度短期调整类型" align="center" prop="adjustShortType" min-width="180"/>

            <el-table-column label="调整前发票额度" align="center" prop="adjustBeforeAmount" width="150"/>

            <el-table-column label="申请调整额度" align="center" prop="adjustAmount" width="150"/>

            <el-table-column label="调整后发票额度" align="center" prop="adjustAfterAmount" width="150"/>

            <el-table-column label="审核时间" align="center" prop="checkTime" width="150"/>

            <el-table-column label="当前办理人员" align="center" prop="nowCheck" width="150"/>

            <el-table-column label="所在部门" align="center" prop="dept" width="150"/>

            <el-table-column label="操作" align="center"
                             min-width="150">
              <template #default="{row}">
                <el-button
                    size="small"
                    type="primary" link
                    @click="notMsg"
                >撤销
                </el-button>

                <el-button
                    size="small"
                    @click="notMsg"
                    type="primary" link>下载申请表
                </el-button>
              </template>
            </el-table-column>


          </el-table>

          <div class="paginate-wrap">
            <span class="total">共 {{ pageTotal }} 条</span>
            <pagination
                :total="pageTotal"
                v-model:page="queryParams.pageNum"
                v-model:limit="queryParams.pageSize"
                layout="sizes,prev, pager, next, jumper"
            />
          </div>

        </div>

        <footer style="display: flex;justify-content: center;padding: 30px 0 0px 0;opacity: 0.9;">
          <img src="https://static.rhkj.com/renhe_fe/other/333.png">
        </footer>
      </div>
    </div>
    <add
        v-else
        @back="showSelf = true"
        @afterAdd="handleAdd"
    />
  </div>
</template>

<script setup>
import myHeader from "../cmp/myHeader.vue";
import add from './add.vue'
import {ElMessage, ElMessageBox} from "element-plus";
import dayjs from "dayjs";
import {convertToNumber} from "@/utils/ruoyi.js";
import {$emit} from "vue-happy-bus";

const queryParams = reactive({
  adjustType: '全部',
  pageNum: 1,
  pageSize: 50,
})
const pageTotal = ref(0)
const answerList = ref([])

const showTableList = ref([])

const rules = reactive({})

const showSelf = ref(true)

function queryData() {
  showTableList.value = answerList.value.filter(f => { // 前端筛选实现
    let pass = true
    if (queryParams.reqStart || queryParams.reqEnd) {
      const c = dayjs(f.reqDate, 'YYYY-MM-DD').startOf('day')
      const s = queryParams.reqStart && dayjs(queryParams.reqStart, 'YYYY-MM-DD').startOf('day') || dayjs('1970-01-01').startOf('day')
      const e = queryParams.reqEnd && dayjs(queryParams.reqEnd, 'YYYY-MM-DD').startOf('day') || dayjs('2100-12-31').startOf('day')
      pass = pass && ((s.isBefore(c) || s.isSame(c)) && (e.isAfter(c) || e.isSame(c)))
    }
    pass = pass && (queryParams.adjustType == '全部' ? true : queryParams.adjustType == f.adjustType)
    if (queryParams.checkStatus?.length) {
      pass = pass && queryParams.checkStatus.includes(f.checkStatus)
    }
    return pass
  })
  pageTotal.value = showTableList.value.length
}

function handleAdd(data) {
  answerList.value.push({
    ...data,
    validDate: '未生效',
    checkStatus: '已提交',
  })
  $emit('exeSaveQa')
  showSelf.value = true
  queryData()
}

function addReq() {
  if (answerList.value.length > 0) {
    ElMessage.warning('已有一条数据处于审核中，不能新增申请！')
    return
  }
  showSelf.value = false
}

function notMsg() {
  ElMessageBox.confirm('本系统为教学系统，暂不支持此功能', '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {
  });
}

const emit = defineEmits(['go-invoice']);

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = () => {
  return {
    solution: JSON.stringify(answerList.value.map(m => ({
      ...m,
      // 将千分位字符串转为数字传给后端
      monthRemainAmount: convertToNumber(m.monthRemainAmount || 0),
      adjustBeforeAmount: convertToNumber(m.adjustBeforeAmount || 0),
      monthAlreadyAmount: convertToNumber(m.monthAlreadyAmount || 0),
      adjustAmount: convertToNumber(m.adjustAmount || 0),
      adjustAfterAmount: convertToNumber(m.adjustAfterAmount || 0),
      validateStartEnd: m.validateStart + ' - ' + m.validateEnd,
      contractValidateStartEnd: m.contractValidateStart + ' - ' + m.contractValidateEnd
    }))),
  }
}

getGrandchildValue.value.fillFinish = () => {
  return Boolean(answerList.value.length)
}

const currentQa = inject('provideCurrentQa');

onMounted(() => {
  answerList.value = (currentQa.value?.solution && JSON.parse(currentQa.value?.solution) || []).map(m => ({
    ...m,
    // 将后端的数字转为前端使用的千分位
    monthRemainAmount: toUS(m.monthRemainAmount),
    adjustBeforeAmount: toUS(m.adjustBeforeAmount || 0),
    monthAlreadyAmount: toUS(m.monthAlreadyAmount || 0),
    adjustAmount: toUS(m.adjustAmount || 0),
    adjustAfterAmount: toUS(m.adjustAfterAmount || 0),
  }))
  queryData()
})

function toUS(ori) {
  return ori.toLocaleString('en-US', {
    //minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function disableReqStart(date) {
  // 开始时间不能大于结束时间
  if (queryParams.reqEnd && dayjs(date).isAfter(dayjs(queryParams.reqEnd, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}

function disableReqEnd(date) {
  // 开始时间不能大于结束时间
  if (queryParams.reqStart && dayjs(date).isBefore(dayjs(queryParams.reqStart, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}
</script>


<style scoped lang="scss">
.page-wrap {
  .content-box {
    height: calc(100vh - 116px);
    background-color: #f2f2f2;
    box-sizing: border-box;
    padding: 24px;
    display: flex;
    flex-direction: column;

    .main-box {
      height: 0;
      flex-grow: 1;
      background-color: #ffffff;
      box-sizing: border-box;
      padding: 24px;

      .paginate-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 25px;

        .total {
          color: #666666;
          font-size: 14px;
        }
      }

      :deep(.adjust-tax-table) {
        .el-table__header {
          th.el-table__cell {
            background-color: #f9fafd;
          }
        }
      }

    }
  }
}
</style>
